import type {GenericAsset} from '../../../../../brand/lib/types/contentful'

// Matches Primer Brand's `isLarge` breakpoint.
export const DESKTOP_MEDIA_QUERY = '(min-width: 1012px)'

export type ResponsiveImages = {
  /** Shown by default, and on small screens. */
  fallback: GenericAsset
  /** The widest image. Shown instead of `fallback` when `DESKTOP_MEDIA_QUERY` matches. */
  desktop?: GenericAsset
}

function getWidth(item: GenericAsset) {
  return item.fields.width ?? item.fields.asset.fields.file.details?.image?.width ?? 0
}

/**
 * Splits a list of images into a default and a desktop image by width:
 *
 * - one image: used everywhere
 * - several images: the widest is used on large screens, the narrowest otherwise
 *
 * Entries that aren't images are ignored.
 */
export function pickResponsiveImages(media: readonly GenericAsset[] | undefined): ResponsiveImages | undefined {
  const images = (media ?? []).filter(item => item.fields.asset.fields.file.details?.image)
  const [first] = images
  if (!first) return undefined

  const byWidth = [...images].sort((a, b) => getWidth(a) - getWidth(b))
  const narrowest = byWidth[0] ?? first
  const widest = byWidth.at(-1) ?? first

  return getWidth(narrowest) === getWidth(widest) ? {fallback: narrowest} : {fallback: narrowest, desktop: widest}
}
